import { inject, Pipe, PipeTransform } from '@angular/core'
import { TextTransformerService } from '@shared/services/text-transformer.service'

@Pipe({
	name: 'amount',
})
export class AmountPipe implements PipeTransform {
	private readonly _textTransformerService: TextTransformerService =
		inject<TextTransformerService>(TextTransformerService)

	transform(value: number | string | null | undefined, withSymbol: boolean = true): string {
		return this._textTransformerService.toAmount(value, withSymbol)
	}
}
